import { Pipe, PipeTransform } from '@angular/core';

import { OPERATOR_SKILLS } from '../../skills/skills.operator';
import { COMMANDER_SKILLS } from '../../skills/skills.commander';
import { EXECUTOR_SKILLS } from '../../skills/skills.executor';

const FOLDERS = { };
const reducer = (folder) => (acc, { name }) => {
  acc[name] = folder;
  return acc;
};

OPERATOR_SKILLS.reduce(reducer('operator'), FOLDERS);
COMMANDER_SKILLS.reduce(reducer('commander'), FOLDERS);
EXECUTOR_SKILLS.reduce(reducer('executor'), FOLDERS);

@Pipe({
  name: 'skillIcon'
})
export class SkillIconPipe implements PipeTransform {

  transform(skillName: string): any {
    const folder = FOLDERS[skillName];

    skillName = skillName.replace(/_/, '-');

    return `assets/icons/${ folder }/${ skillName }.svg`;
  }

}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/skill-icon.pipe/skill-icon.pipe.ts